import {Component, Input, OnInit, ViewEncapsulation, Injector, PLATFORM_ID, Inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {AbstractComponent} from '../abstract.component';
import { ModalService } from '@shopping-angular-components/modal';
import { ModalData } from '@shopping-angular-components/modal/lib/models/ModalData.model';
import {ImagesGallerySliderComponent} from '@shopping-angular-components/images-gallery-slider'
import {MediaPictureService} from "../../services/media-picture.service";
import {SliderOptions} from "../slider/slider/slider.component";
import {ScreenType} from "../../model/ScreenType";
import {Module} from "../../model/ModuleModel";
import {HotelImagesGalleryModel, ImageGallery} from "./hotel-images-gallery.model";
import { UpaService, UpaTarget } from './../../services/upa.service';

class PreviewModel {
  previewImage: string;
  secondaryImage: string;
  categoryName: string;
  categoryTag: string;

  constructor(imageKey, secondaryImage, category, length) {
    this.previewImage = imageKey;
    this.secondaryImage = secondaryImage;
    this.categoryName = category;
    if(category && length) {
      this.categoryTag = category + ' ' + '(' + length + ')'
    }
  }
}

@Component({
  selector: 'hotel-images-gallery',
  template: `
    <div id="hotel-images-gallery">
      <main-title *ngIf="module" [data]="module" class="title-container side" titleColor="#444" preTitleColor="#888" subtitleColor="#888" [moduleId]="module.id" [uniqueId]="module.unique_id"></main-title>
      <div *ngIf="deviceType === 'DESKTOP' && picturesCategories?.length">
        <div class="parent GALLERY-{{previewModel.length}}">
          <div *ngFor="let preview of previewModel, let i = index" class="miniature{{i}}" (click)="openModal(preview.categoryName, i)">
            <img [src]="this.mediaPictureService.getMediaUrl(preview.previewImage)" [alt]="resolveAlt(i, preview.categoryName)" (error)="onImgError($event, preview.secondaryImage, null)">
            <span *ngIf="preview.categoryTag" class="eva-3-driver -eva-3-bc-white -eva-3-tc-gray-1 -eva-3-mr-xlg">
                <span class="driver-text -font-weight-300">{{preview.categoryTag}}</span>
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="deviceType !== 'DESKTOP' && picturesCategories?.length" class="mobile-gallery">

        <!-- TODO MIGRAR A SLIDER PRO -->
        <slider *ngIf="!previewMobile" [options]="sliderOptions" [moduleId]="module.id" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id">
          <slider-item *ngFor="let preview of previewModel, let i = index" class="slider-item" (click)="openModal(preview.categoryName, i)">
            <img [ngStyle]="{'width': this.mobileImageContainerWidth+'px'}" [src]="mediaPictureService.getMediaUrl(preview.previewImage, (this.mobileImageContainerWidth+'x210'))" [alt]="resolveAlt(i, preview.categoryName)"
                 (error)="onImgError($event, preview.secondaryImage, (this.mobileImageContainerWidth+'x210'))" loading="lazy">
          </slider-item>
        </slider>
        <div *ngIf="previewMobile" class="pre-image">
          <img [ngStyle]="{'width': this.mobileImageContainerWidth+'px'}" [src]="mediaPictureService.getMediaUrl(previewModel[0].previewImage, ('420x210'))" [alt]="resolveAlt(0, previewModel[0].categoryName)"
               (error)="onImgError($event, previewModel[0].secondaryImage, ('420x210'))" loading="lazy">
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./hotel-images-gallery.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HotelImagesGalleryComponent extends AbstractComponent implements OnInit {
  private MODULE_ID: string = "HotelDetailImageGalleryModule";

  @Input() override module: Module<HotelImagesGalleryModel>;
  picturesCategories: ImageGallery[];
  hotelName: string;
  deviceType: ScreenType;
  previewModel: PreviewModel[];
  modalData: ModalData;
  sliderOptions: SliderOptions;
  mobileImageContainerWidth?: number;
  previewMobile: boolean = true;
  isWebview: boolean;

  constructor(injector: Injector, private modalService: ModalService,
    public mediaPictureService: MediaPictureService,
    @Inject(PLATFORM_ID) private platformId: string) {

    super(injector);
  }

  ngOnInit(): void {
    this.deviceType = this.screenType;
    this.picturesCategories = this.module.data.image_galleries;
    this.hotelName = this.module.data.hotel_name;
    this.previewModel = this.resolvePreviewModel();
    this.modalData = {
      id: 'image-gallery-slider-modal',
      contentComponent: ImagesGallerySliderComponent,
      product: this.product,
      flow: this.flow,
      isWebview: this.isWebview,
      contentModel: {
        pictures: this.picturesCategories,
        product: this.product,
        flow: this.flow,
      },
      fullScreen: true
    };
    if (this.screenType != 'DESKTOP' && isPlatformBrowser(this.platformId)) {
      this.mobileImageContainerWidth = document.getElementById('hotel-images-gallery')?.clientWidth;
      this.previewMobile = false;
      this.sliderOptions = {
        id: 'preview-images-carrousel-mobile',
        show_arrows: true,
        show_dots: true,
        dots_inside: true,
        items_to_show: 1,
        items_length: this.previewModel?.length,
        max_fixed_width: 768,
        mobile_card_size: 100,
        items_to_move: 1,
        space_between: 0,
        arrows_size: '-sm',
        show_loader: true,
        deactivate_touch: false,
        arrows_inner_container: true
      }
    }
  }

  resolvePreviewModel() : PreviewModel[] {
    const PRIMARY_CATEGORIES_Q = 7;
    const SECONDARY_CATEGORIES_Q = 5;
    let categoriesQuantity = this.picturesCategories?.length;
    if(categoriesQuantity >= PRIMARY_CATEGORIES_Q){
      return this.getPicturesByCategoriesQuantity(PRIMARY_CATEGORIES_Q);
    }
    else if(categoriesQuantity >= SECONDARY_CATEGORIES_Q && categoriesQuantity < PRIMARY_CATEGORIES_Q){
      return this.getPicturesByCategoriesQuantity(SECONDARY_CATEGORIES_Q);
    }
    else if (categoriesQuantity > 0) {
      return this.picturesCategories?.[0]?.images?.slice(0,SECONDARY_CATEGORIES_Q)
        .map((imageKey, index) => {
          let secondaryImage = [...this.picturesCategories[0].images].reverse()[0];
          if(index === 0 ) {
            return new PreviewModel(imageKey, secondaryImage , this.picturesCategories[0].category, this.picturesCategories[0].images.length)
          }else {
            return new PreviewModel(imageKey, secondaryImage, null, null)
          }
        })
    }
    else {
      return [];
    }
  }

  private getPicturesByCategoriesQuantity(toIndex) {
    return this.picturesCategories.slice(0, toIndex).map((group, index) => {
      let principalImage = group.images[0];
      if(index == 0) {
        principalImage = group.images[1];
      }
      return new PreviewModel(principalImage, [...group.images].reverse()[0], group.category, group.images.length)
    });
  }

  openModal(categorySelected, imageIndex) {
    this.modalData.contentModel['categorySelected'] = categorySelected;
    this.modalService.showModal(this.modalData);

    if (this.deviceType === 'DESKTOP'){

      this.upaService.trackClickTopic({
        label: `${this.hotelName}-${categorySelected}-${imageIndex}`,
        moduleId: this.getModuleId(),
        uniqueId: this.module.unique_id,
        moduleIndex: this.module.row_number,
        target: UpaTarget.IMAGE
      });
    }
  }

  getModuleId(): string {
    return this.MODULE_ID;
  }

  onImgError(event, secondaryImage, mobileSize) {
    event.target.src = this.mediaPictureService.getMediaUrl(secondaryImage, mobileSize);
  }

  resolveAlt(index, categoryName) {
    if(index == 0 || !categoryName || ["Indefinido", "Undefined"].includes(categoryName)){
      return "";
    }
    return categoryName + " " + this.hotelName;
  }
}
